import cloneDeep from 'lodash-es/cloneDeep';
import { ISurveySettingsContext } from './SurveySettingsContext';

export enum SurveySettingsActions {
  SET_SURVEY_SETTING_CHANGED = 'SET_SURVEY_SETTING_CHANGED',
  SET_RATING_WORKFLOW_CHANGED = 'SET_RATING_WORKFLOW_CHANGED',
  SET_POSITIVE_WORKFLOW_CHANGED = 'SET_POSITIVE_WORKFLOW_CHANGED',
  SET_NEGATIVE_WORKFLOW_CHANGED = 'SET_NEGATIVE_WORKFLOW_CHANGED',
  ADD_CHANGED_SURVEY_APPOINTMENT_TYPE_SETTING_ID = 'ADD_CHANGED_SURVEY_APPOINTMENT_TYPE_SETTING_ID',
  CLEAR_ALL_CHANGES = 'CLEAR_ALL_CHANGES',
  UPDATE_SETTINGS_ID = 'UPDATE_SETTINGS_ID',
  UPDATE_SURVEY_TYPE = 'UPDATE_SURVEY_TYPE',
  UPDATE_GENERAL_SETTINGS = 'UPDATE_GENERAL_SETTINGS',
  UPDATE_COMPOSE_SETTINGS = 'UPDATE_COMPOSE_SETTINGS',
  UPDATE_APPOINTMENT_TYPE_SETTINGS = 'UPDATE_APPOINTMENT_TYPE_SETTINGS',
  SET_IS_LOADING = 'SET_IS_LOADING',
  SET_IS_SAVING = 'SET_IS_SAVING',
  SET_SURVEY_ENABLED = 'SET_SURVEY_ENABLED',
  SET_SURVEY_EDITOR_VIEW = 'SET_SURVEY_EDITOR_VIEW',
}

interface ActionProps {
  type: SurveySettingsActions;
  // eslint-disable-next-line
  payload: any;
}

export const surveySettingsReducer = (_state: ISurveySettingsContext, action: ActionProps): ISurveySettingsContext => {
  const newState = cloneDeep(_state);
  const { type, payload } = action;

  switch (type) {
    case SurveySettingsActions.SET_SURVEY_SETTING_CHANGED:
      newState.changedSettings.surveySettingChanged = payload;
      return newState;
    case SurveySettingsActions.SET_RATING_WORKFLOW_CHANGED:
      newState.changedSettings.ratingWorkflowChanged = payload;
      return newState;
    case SurveySettingsActions.SET_POSITIVE_WORKFLOW_CHANGED:
      newState.changedSettings.positiveWorkflowChanged = payload;
      return newState;
    case SurveySettingsActions.SET_NEGATIVE_WORKFLOW_CHANGED:
      newState.changedSettings.negativeWorkflowChanged = payload;
      return newState;
    case SurveySettingsActions.ADD_CHANGED_SURVEY_APPOINTMENT_TYPE_SETTING_ID:
      if (!newState.changedSettings.surveyAppointmentTypeSettingIds.includes(payload)) {
        newState.changedSettings.surveyAppointmentTypeSettingIds.push(payload);
      }
      return newState;
    case SurveySettingsActions.CLEAR_ALL_CHANGES:
      newState.changedSettings = {
        surveySettingChanged: false,
        ratingWorkflowChanged: false,
        positiveWorkflowChanged: false,
        negativeWorkflowChanged: false,
        surveyAppointmentTypeSettingIds: [],
      };
      return newState;
    case SurveySettingsActions.UPDATE_SETTINGS_ID:
      newState.surveySettingId = payload;
      return newState;
    case SurveySettingsActions.UPDATE_SURVEY_TYPE:
      newState.surveyType = payload;
      return newState;
    case SurveySettingsActions.UPDATE_GENERAL_SETTINGS:
      newState.generalSettings = payload;
      return newState;
    case SurveySettingsActions.UPDATE_COMPOSE_SETTINGS:
      newState.composeSettings = payload;
      return newState;
    case SurveySettingsActions.UPDATE_APPOINTMENT_TYPE_SETTINGS:
      newState.appointmentTypeSettings = payload;
      return newState;
    case SurveySettingsActions.SET_IS_LOADING:
      newState.isLoading = payload;
      return newState;
    case SurveySettingsActions.SET_IS_SAVING:
      newState.isSaving = payload;
      return newState;
    case SurveySettingsActions.SET_SURVEY_ENABLED:
      newState.surveyEnabled = payload;
      return newState;
    case SurveySettingsActions.SET_SURVEY_EDITOR_VIEW:
      newState.currentEditorView = payload;
      return newState;
    default:
      return newState;
  }
};
